<template>
  <section>
    <notifications></notifications>

    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />

    <base-header>
      <div class="row align-items-center  pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>

        <div class="col-lg-8 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              type="primary"
              @click="openModal('btn')"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Schedule</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-7 col-sm-12 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search py-0">
                <b-input-group-prepend
                  class="pt-1 pl-1 d-sm-inline-block d-none"
                >
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>

                <el-select
                  placeholder="Select Driver"
                  v-model="filterSchedule"
                  id="branch_name"
                  name="branch_name"
                  filterable
                  multiple
                  reserve-keyword
                  @change="searchDrivers"
                  value
                  class="select-filter d-inline-flex"
                  clearable
                >
                  <el-option
                    v-for="(option, index) in drivers"
                    :value="option._id"
                    :label="`${option.first_name} ${option.last_name}`"
                    :key="index"
                  ></el-option>
                </el-select>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12 text-right align-self-center"
          >
            <div>
              <div class="box-buttons">
                <div class="d-inline-block">
                  <el-tooltip content="Help" placement="bottom">
                    <base-button
                      type="outline-neutral"
                      class="btn-icon-only mb-0"
                      @click="openSideBar"
                    >
                      <i class="flaticon-question-1 f-16 mr-0"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-table">
        <template>
          <full-calendar
            :events="ocurrencies"
            :plugins="calendarPlugins"
            :defaultDate="today"
            contentHeight="auto"
            :theme="true"
            ref="calendari"
            class="calendar"
            :defaultView="defaultView"
            :header="header"
            :weekends="weekends"
            :selectable="selectable"
            :selectHelper="selectHelper"
            :selectMirror="selectMirror"
            :dayMaxEvents="dayMaxEvents"
            :editable="editable"
            :eventAllow="eventAllow"
            slotEventOverlap="true"
            @select="handleDateSelect"
            @eventClick="handleEventClick"
            @eventsSet="handleEvents"
            @eventDrop="eventDrop"
            @eventResize="eventResize"
            @datesRender="handlleChangeView"
          ></full-calendar>
        </template>

        <newschedule
          :value="modalOpen"
          @close="closedModal"
          @add="addEvents"
          :drivers="drivers"
          :selectInfo="selectInfo"
          :origin="origin"
        ></newschedule>
        <editschedule
          :value="editModal"
          :drivers="drivers"
          :scheduleUser="schedule"
          :event="event"
          @delete="deleteEvent"
          @update="updateEvent"
        ></editschedule>
      </div>

      <div v-if="modalDragAndDrop">
        <modal
          :show="modalDragAndDrop"
          size="sm"
          @close="closeModalDragAndDrop"
          footerClasses="pt-3 col-12"
          bodyClasses="pb-2 pt-2"
        >
          <template slot="header">
            <h4 class="underline">Update Recurring Event</h4>
          </template>
          <div class="col-12 options-pers">
            <base-radio
              name="only"
              id="only"
              class="mb-2"
              v-model="optionModalDragAndDrop"
              >This Event</base-radio
            >
            <base-radio name="all" id="all" v-model="optionModalDragAndDrop"
              >All events</base-radio
            >
          </div>
          <template slot="footer">
            <div class="col-xl-6">
              <el-tooltip content="Cancel" placement="right">
                <base-button
                  type="danger"
                  class="btn-icon-only"
                  @click="closeModalDragAndDrop()"
                >
                  <i class="flaticon-cancel"></i>
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-xl-6 text-right">
              <el-tooltip content="Accept" placement="left">
                <base-button
                  type="primary"
                  class="btn-icon-only"
                  @click="updateEventDragAndDrop()"
                  :disabled="disalbleButtonModalDragAndDrop"
                >
                  <i class="fas fa-check"></i>
                </base-button>
              </el-tooltip>
            </div>
          </template>
        </modal>
      </div>
    </div>
  </section>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import format from "date-fns/format";
import endpoint from "../../Commons/Services/index";
import NewScheduleAll from "../Components/NewSchedule";
import EditScheduleAll from "../Components/EditSchedule";
import AllLoader from "rhomtrip_assets/src/components/Loader/Loader.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import moment, { months } from "moment-timezone";
import localHelper from "../Commons/Helper";
import { goBack, unauthorizedAction } from "../../../helpers/commons.helpers";

const today = new Date();
export default {
  name: "calendar",
  data() {
    return {
      modalOpen: false,
      calendarPlugins: [
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
        listPlugin
      ],
      defaultView: "dayGridMonth",
      year: today.getFullYear(),
      today: format(today, "YYYY-MM-DD"),
      header: {
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth"
      },
      weekends: true,
      editable: !true,
      droppable: false,
      selectable: true,
      selectMirror: true,
      dayMaxEvents: true,
      selectHelper: true,
      currentEvents: [],
      timezone: "",
      events: [],
      event: null,
      _id: null,
      driver: null,
      drivers: [],
      reservations: [],
      selectInfo: null,
      clickInfo: null,
      currentMonth: moment().month(),
      currentYear: moment().year(),
      editModal: false,
      schedule: null,
      eventsCopy: [],
      option: "",
      modalQuestion: false,
      filterSchedule: [],
      barfilter: false,
      ocurrencies: [],
      origin: "multiple",
      create: "btn",
      /**Modal updated Drag and Drop */
      disalbleButtonModalDragAndDrop: false,
      dargAndDrop: {
        newEvent: null,
        oldEvent: null,
        daysMove: 0,
        revert: null
      },
      optionModalDragAndDrop: "only",
      modalDragAndDrop: false,
      radioOptions: [
        { value: "1", label: "All" },
        { value: "2", label: "Custom" }
      ],
      buttonfilters: "1",
      visibleSideBar: false,
      guides: [],
      loader: false
    };
  },
  async created() {
    moment.tz.setDefault();
    this.currentMonth = moment().month();
    this.currentYear = moment().year();
    this.setLoad(true);
    this.getAllEvents(this.currentMonth, this.currentYear, this.sesion.token);
    var bread = [
      {
        text: "Drivers Schedule",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },
  watch: {
    filterSchedule: function(newVal, oldVal) {
      if (oldVal.length > newVal.length) {
        if (newVal.length === 0) {
          this.ocurrencies = this.events;
        } else {
          this.ocurrencies = this.events.filter(element => {
            return newVal.indexOf(element.driver) > -1;
          });
        }
      }
    }
  },
  methods: {
    closeModalDragAndDrop() {
      this.modalDragAndDrop = !this.modalDragAndDrop;
      this.dargAndDrop.revert();
    },
    changeOption(option) {
      if (option == 1) {
        this.filterSchedule = [];
        this.ocurrencies = this.events;
        this.barfilter = false;
      } else {
        this.barfilter = true;
      }
    },
    openformschedule() {
      this.modalQuestion = !this.modalQuestion;
    },
    handlleChangeView(args) {
      try {
        var currentStart = args.view.currentStart;
        var date = moment(currentStart);
        let currentYear = date.year();
        let currentMonth = date.month();

        if (currentMonth === this.currentMonth) {
        } else {
          this.currentMonth = currentMonth;
          this.currentYear = currentYear;

          let driver = this.getAllEvents(
            this.currentMonth,
            this.currentYear,
            this.sesion.token
          );
        }
      } catch (error) {
        console.log("Error");
      }
    },
    getAllEvents(month, year, token) {
      endpoint.drivers.services
        .getAllEvents(month, year, token)
        .then(response => {
          let result = response.data;
          if (result.status) {
            this.setLoad(false);
            let data = result.data;
            let drivers = data.drivers;
            this.eventsCopy = data.events;
            this.events = data.events;
            if (this.filterSchedule.length > 0) {
              this.ocurrencies = data.events.filter(element => {
                return this.filterSchedule.indexOf(element.driver) > -1;
              });
            } else {
              this.ocurrencies = data.events;
            }
            this.reservations = data.reservations;
            this.drivers = drivers.map(element => {
              return {
                _id: element._id,
                first_name: element.person.first_name,
                last_name: element.person.last_name,
                timezone:
                  element.relationship.branch === null
                    ? ""
                    : element.relationship.branch.timezone
              };
            });
          }
        })
        .catch(error => {
          this.setLoad(false);
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        });
    },
    addEvents(data) {
      this.eventsCopy = this.eventsCopy.concat(data.events);
      this.ocurrencies = this.ocurrencies.concat(data.events);
      this.events = this.events.concat(data.events);
    },
    deleteEvent(status) {
      if (status) {
        this.setLoad(true);
        let driver = this.getAllEvents(
          this.currentMonth,
          this.currentYear,
          this.sesion.token
        );
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Event has been Deleted",
          icon: "flaticon-check-3"
        });
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The event could not be deleted. Please check and try again",
          icon: "flaticon-remove"
        });
      }
    },
    updateEvent(status) {
      if (status) {
        this.setLoad(true);
        let driver = this.getAllEvents(
          this.currentMonth,
          this.currentYear,
          this.sesion.token
        );
        this.$notify({
          type: "success",
          title: "Success!",
          message: "Event Updated",
          icon: "flaticon-check-3"
        });
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The event could not be updated. Please check and try again",
          icon: "flaticon-remove"
        });
      }
    },
    handleWeekendsToggle() {
      this.weekends = !this.weekends;
    },
    overlap(events, event) {
      try {
        let flag = false;
        events.forEach((element, index) => {
          let days = moment(
            moment(event.end)
              .utc(true)
              .format("YYYY-MM-DD")
          ).diff(
            moment(event.start)
              .utc(true)
              .format("YYYY-MM-DD"),
            "days"
          );
          if (days > 0) {
            let one = moment(moment(element.start).utc(true)).isBetween(
              moment(event.start).utc(true),
              moment(event.end).utc(true),
              "minute",
              []
            );
            let two = moment(moment(element.end).utc(true)).isBetween(
              moment(event.start).utc(true),
              moment(event.end).utc(true),
              "minute",
              []
            );
            if (one && two) {
              flag = true;
            } else if (one && !two) {
              flag = true;
            } else if (!one && two) {
              flag = true;
            }
          } else {
            let one = moment(moment(event.start).utc(true)).isBetween(
              moment(element.start).utc(true),
              moment(element.end).utc(true),
              "minute",
              []
            );
            let two = moment(moment(event.end).utc(true)).isBetween(
              moment(element.start).utc(true),
              moment(element.end).utc(true),
              "minute",
              []
            );
            if (one && two) {
              flag = true;
            } else if (one && !two) {
              flag = true;
            } else if (!one && two) {
              flag = true;
            }
          }
        });
        return flag;
      } catch (error) {
        return true;
      }
    },
    eventDrop(eventDropInfo) {
      try {
        let driver = this.eventsCopy.find(
          element => element.id === eventDropInfo.event.id
        );
        let events = this.eventsCopy.filter(
          element =>
            element.driver === driver.driver &&
            element.id !== eventDropInfo.event.id
        );
        if (!this.overlap(events, eventDropInfo.event)) {
          this.dargAndDrop.newEvent = eventDropInfo.event;
          this.optionModalDragAndDrop = "only";
          this.dargAndDrop.oldEvent = eventDropInfo.oldEvent;
          this.dargAndDrop.daysMove = eventDropInfo.delta.days;
          this.dargAndDrop.revert = eventDropInfo.revert;
          this.modalDragAndDrop = true;
        } else {
          eventDropInfo.revert();
          this.showNotify(
            "danger",
            "Error!",
            "You cannot overlap two events for the same driver. Please try again!"
          );
        }
      } catch (error) {
        eventDropInfo.revert();
        this.showNotify(
          "danger",
          "Error!",
          "The Operation could not be completed. Please try again"
        );
      }
    },
    eventResize(eventResizeInfo) {
      try {
        let driver = this.eventsCopy.find(
          element => element.id === eventResizeInfo.event.id
        );
        let events = this.eventsCopy.filter(
          element =>
            element.driver === driver.driver &&
            element.id !== eventResizeInfo.event.id
        );
        if (!this.overlap(events, eventResizeInfo.event)) {
          this.optionModalDragAndDrop = "only";
          this.dargAndDrop.newEvent = eventResizeInfo.event;
          this.dargAndDrop.oldEvent = eventResizeInfo.prevEvent;
          this.dargAndDrop.daysMove = eventResizeInfo.endDelta.days;
          this.dargAndDrop.revert = eventResizeInfo.revert;
          this.modalDragAndDrop = true;
        } else {
          eventResizeInfo.revert();
          this.showNotify(
            "danger",
            "Error!",
            "You cannot overlap two events for the same driver. Please try again!"
          );
        }
      } catch (error) {
        eventResizeInfo.revert();
        this.showNotify(
          "danger",
          "Error!",
          "The Operation could not be completed. Please try again"
        );
      }
    },
    handleDateSelect(selectInfo) {
      let days = moment(moment(selectInfo.end).utc(true)).diff(
        moment(selectInfo.start).utc(true),
        "days"
      );
      if (!(days <= 2)) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "They can only have one day of difference between the two dates, please try again",
          icon: "flaticon-remove"
        });
      } else {
        this.clickInfo = null;
        this.selectInfo = selectInfo;
        this.openModal("calendar");
      }
    },
    async handleEventClick(clickInfo) {
      try {
        let event = this.eventsCopy.find(
          element => element.id === clickInfo.event.id
        );
        this.event = event;
        let split = this.event.id.split("-");
        let _id = this.event.id;
        let group_id = split[split.length - split.length];
        let { data } = await endpoint.drivers.services.getOneSchedule(
          group_id,
          this.sesion.token
        );
        if (data.status) {
          let result = data.data;
          this.schedule = result.schedule;
          this.modalQuestion = !this.modalQuestion;
          this.openModalEdit();
        }
        return;
      } catch (error) {
        let auth = unauthorizedAction(error);
        if (auth) {
          this.setSigOut(true);
        }
        return;
      }
    },
    handleEvents(events) {
      this.currentEvents = events;
    },
    closedModal(status) {
      this.modalOpen = false;
    },
    openModal(create = "btn") {
      this.create = create;
      this.modalOpen = !this.modalOpen;
    },
    eventAllow: function(dropInfo, draggedEvent) {
      let flag = true;
      let event = this.eventsCopy.find(
        element => element.id === draggedEvent.id
      );
      this.reservations.forEach((element, index) => {
        if (element.driver === event.driver) {
          let pickup_date = this.getPickupDate(element);
          let isBetween =
            moment(moment(pickup_date).utc(true)).isSameOrAfter(
              moment(event.start).utc(true),
              "minutes"
            ) &&
            moment(moment(pickup_date).utc(true)).isSameOrBefore(
              moment(event.end).utc(true),
              "minutes"
            );
          if (isBetween) {
            flag = false;
          }
        }
      });
      return flag;
    },
    getPickupDate(element) {
      let pickup_date =
        moment(element.pickup_date)
          .utc()
          .hours() > 0
          ? moment(element.pickup_date).add(1, "days")
          : moment(element.pickup_date).utc();
      let date = moment(pickup_date)
        .set("hour", moment(element.pickup_time, "h:mm A").get("hour"))
        .set("minute", moment(element.pickup_time, "h:mm A").get("minutes"));
      return date.format("YYYY-MM-DDTHH:mm:ss");
    },
    openModalEdit() {
      this.editModal = !this.editModal;
    },
    searchDrivers() {
      if (this.filterSchedule.length > 0) {
        this.ocurrencies = this.events.filter(element => {
          return this.filterSchedule.indexOf(element.driver) > -1;
        });
      } else {
        this.ocurrencies = this.events;
      }
    },
    async updateEventDragAndDrop() {
      try {
        this.disalbleButtonModalDragAndDrop = true;
        let split = this.dargAndDrop.newEvent.id.split("-");
        let _id = split[split.length - split.length];
        let option = this.optionModalDragAndDrop;
        let event = {
          _id: this.dargAndDrop.newEvent.id,
          start: moment(this.dargAndDrop.newEvent.start)
            .utc(true)
            .format("YYYY-MM-DDTHH:mm:ss"),
          end: moment(this.dargAndDrop.newEvent.end)
            .utc(true)
            .format("YYYY-MM-DDTHH:mm:ss")
        };
        let {
          data
        } = await endpoint.drivers.services.updateScheduleDragAndDrop(
          _id,
          option,
          event,
          this.dargAndDrop.daysMove,
          this.sesion.token
        );
        this.modalDragAndDrop = false;
        if (data.status) {
          this.setLoad(true);
          let driver = this.getAllEvents(
            this.currentMonth,
            this.currentYear,
            this.sesion.token
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "Event moved & saved successfully",
            icon: "flaticon-check-3"
          });
          this.disalbleButtonModalDragAndDrop = false;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The event could not be moved. Please check again",
            icon: "flaticon-remove"
          });
          this.disalbleButtonModalDragAndDrop = false;
        }
      } catch (error) {
        this.modalDragAndDrop = false;
        if (error.response) {
          let { data } = error.response;
          if (data.code === 401) {
            let auth = unauthorizedAction(error);
            if (auth) {
              this.setSigOut(true);
            }
          } else {
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "The event could not be moved. Please check again",
              icon: "flaticon-remove"
            });
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The event could not be moved. Please check again",
            icon: "flaticon-remove"
          });
          this.disalbleButtonModalDragAndDrop = false;
        }
      }
    },
    showNotify(type, title, message) {
      this.$notify({
        type: type,
        title: title,
        message: message,
        icon: "flaticon-check-3"
      });
    },
    goToPreviousPage() {
      goBack(this);
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("SUPPLIERS", "SCHEDULE");
      this.loader = false;
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await endpoint.documents.services.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    ...mapActions(["getModalSchedule"]),
    ...mapMutations([
      "setModalSchedule",
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setDriversSearchCriteria"
    ])
  },
  computed: {
    ...mapGetters(["ModalSchedule", "sesion", "sigout"])
  },
  components: {
    FullCalendar,
    newschedule: NewScheduleAll,
    editschedule: EditScheduleAll,
    loader: AllLoader
  },
  beforeRouteLeave(to, from, next) {
    localHelper.isInDriversModule(
      to.meta.modules,
      this.setDriversSearchCriteria,
      "drivers"
    );
    next();
  }
};
</script>

<style lang="scss">
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";
@import "~@fullcalendar/list/main.css";
@import "@/scss/styles.scss";
@import "~rhomtrip_assets/src/sass/core/vendors/fullcalendar";
</style>
